import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { AutoSaveModule } from '../shared/components/autosave/autosave.module';
import { StepDescriptionModule } from '../shared/components/step-description/step-description.module';
import { UtilService } from '../shared/services/util.service';
import { FinalFeedbackService } from 'src/app/final-feedback/final-feedback.service';
import { FinalFeedbackValidationPage } from 'src/app/final-feedback-validation/final-feedback-validation.page';
import { FinalFeedbackReviewPage } from 'src/app/final-feedback-validation/final-feedback-review/final-feedback-review.page';
import { QuestionTypesModule } from 'src/app/shared/components/question-types/question-types.module';
import {MatLegacyTooltipModule as MatTooltipModule} from "@angular/material/legacy-tooltip";
import { ReviewEvaluationsModal } from '../shared/components/review-evaluations/review-evaluations.modal';

// import { Review360EvaluationModal } from '../manager-evaluation/evaluate-team/review-360-evaluation/review-360-evaluation.modal';

const routes: Routes = [{
    path: '',
    component: FinalFeedbackValidationPage
}, {
    path: ':userId',
    component: FinalFeedbackReviewPage
}];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        PipesModule,
        FormsModule,
        ReactiveFormsModule,
        StepDescriptionModule,
        AutoSaveModule,
        QuestionTypesModule,
        MatTooltipModule,
    ],
    declarations: [
        FinalFeedbackValidationPage,
        FinalFeedbackReviewPage
    ],
    providers: [
        FinalFeedbackService,
        UtilService
    ]
})
export class FinalFeedbackValidationModule { }
